export enum DiscountType {
    FixedAmount = 1,
    Percentage = 2,
}

export const DiscountTypeLabels: Record<DiscountType, string> = {
    [DiscountType.FixedAmount]: "Fixed Amount",
    [DiscountType.Percentage]: "Percentage",
};